angular.module('tf.directives')

    .directive('asyncImage', ['HttpService','FarmerService','$q','$rootScope',function (HttpService, FarmerService, $q, $rootScope) {
    return{
        restrict:'E',
        replace:true,
        scope:{
            fid:"=",
            image:'=',
            base64image:'=',
            defaultImage:'=',
            quality : '@',
            maxSize : '@'
        },
        templateUrl:'js/components/asyncImage/asyncImage.html',
        link: function(scope,element,attr){
            scope.isLoaded=false;
            var image = scope.image;
            var base64image = scope.base64image;
            var imageElement =angular.element(element[0].getElementsByClassName('gallery-img'));
            if (image){

                var cancler = $q.defer();
                $rootScope.$on('$stateChangeStart', function() {
                    cancler.resolve();
                });
                HttpService.get('farmer/'+ (scope.fid || FarmerService.fid()) +'/image/', _.omit({image: image, size : scope.maxSize, quality : scope.quality}, _.isUndefined), false, {timeout: cancler.promise})
                    .then(function (res) {
                        imageElement.css({
                            'background-image': 'url(data:image/JPEG;base64,' + res.data + ')',
                            'background-size': 'cover'
                        });
                        scope.isLoaded=true;
                    }, function(){
                        imageElement.css({
                            'background-image':'url(' +scope.defaultImage+')',
                            'background-size': 'contain',
                            'background-repeat': 'no-repeat'
                        });
                        scope.isLoaded=true;
                    });
            }else if (base64image){
                imageElement.css({
                    'background-image': 'url(data:image/JPEG;base64,' + base64image + ')',
                    'background-size': 'cover'
                });
                scope.isLoaded=true;
            }else {
                imageElement.css({
                    'background-image':'url(' +scope.defaultImage+')',
                    'background-size': 'contain',
                    'background-repeat': 'no-repeat'
                });
                scope.isLoaded=true;
            }
        }
    };
}]);
